import React, { useState } from 'react';
import { DragDropContext } from 'react-beautiful-dnd';
import { Toggle } from '@blueprintnyc/bpnyc-common-admin';
import cloneDeep from 'lodash/cloneDeep';
import WidgetButtons from 'components/WidgetButtons';
import WidgetDevicePreview from './WidgetDevicePreview';
import WidgetBuilderSettings from './WidgetBuilderSettings';
import WidgetUpdate from './WidgetUpdate';
import { widgetTypes } from '@/components/Widgets';
import { reorder } from 'utils';

const WidgetBuilder = props => {
	const {
		widgets,
		handleWidgetDelete,
		handleWidgetUpdate,
		setWidgets,
		setHasChanges,
		showUpdateOptions,
		setShowUpdateOptions,
		preview,
	} = props;

	const [controls, setControls] = useState('content');

	const onDelete = (e, widget) => {
		e.stopPropagation();
		handleWidgetDelete(widget);
		setShowUpdateOptions(false);
	};

	const handleDragEnd = result => {
		const { source, destination, draggableId } = result;

		if (!destination || destination.droppableId !== 'previewer') return;

		const clonedWidgetTypes = cloneDeep(widgetTypes);
		const newWidget = clonedWidgetTypes.find(item => item.type === draggableId.split('-')[0]);

		if (destination.droppableId === 'previewer') {
			if (source.droppableId !== destination.droppableId) {
				// add new widget logic
				setWidgets(
					[...widgets.slice(0, destination.index), newWidget, ...widgets.slice(destination.index)],
					'WidgetBuilder.handleDragEnd.insert'
				);
				handleWidgetUpdate(newWidget, destination.index);
			} else {
				// reorder within previewer logic
				const reorderedList = reorder(widgets, result.source.index, result.destination.index);
				setWidgets(reorderedList, 'WidgetBuilder.handleDragEnd.reorder');
			}
			setHasChanges(true);
		}
	};

	const showSettings = controls === 'settings';

	const handleShowControls = device => {
		setControls(device);
		setShowUpdateOptions(false);
	};

	return (
		<div className="WidgetBuilder">
			<DragDropContext onDragEnd={handleDragEnd}>
				<div
					className="WidgetPreviewContainer"
					style={{ flex: preview === 'desktop' ? 3 : preview === 'tablet' ? 1 : 0.4 }}
				>
					<WidgetDevicePreview {...props} onDelete={onDelete} />
				</div>
				<div className="WidgetBuilderControls">
					<Toggle
						toggleOptions={['content', 'settings']}
						value={controls}
						onChange={handleShowControls}
					/>
					{showUpdateOptions ? (
						<WidgetUpdate {...props} />
					) : showSettings ? (
						<WidgetBuilderSettings {...props} />
					) : (
						<WidgetButtons />
					)}
				</div>
			</DragDropContext>
		</div>
	);
};

export default WidgetBuilder;
